import { RcFile } from 'antd/es/upload'
import React from 'react'
import { UseFormReturn } from 'react-hook-form'
import { IFileMapping, ISubmitIssuedCheckFile } from 'src/app/shared/models/issuedCheck.model'

type BeforeUploadValueType = void | boolean | string | Blob | File

export interface FormValues {
  clientId: string | null
  file: any
  accountId: string | null | undefined
  mappingFormat: string | null
}

export interface SubmitIssuedCheckProps {
  form: UseFormReturn<FormValues>
  clients: Array<{
    id: string
    clientName: string
  }>
  accounts: Array<{
    accountName: string
    accountId: string
  }>
  fileMappings: Array<IFileMapping>
  checkList: ISubmitIssuedCheckFile.Response | null
  loading: boolean
  loadingClients: boolean
  listLoading: boolean
  disabled: boolean
  validatedFromBE: boolean
  onSubmit: (values: FormValues) => Promise<any>
  setValidatedFromBE: React.Dispatch<React.SetStateAction<boolean>>
  beforeUpload: (
    file: RcFile,
    FileList: RcFile[],
    fromDrag?: boolean,
  ) => BeforeUploadValueType | Promise<BeforeUploadValueType>
}

export const SubmitIssuedCheckFileContext = React.createContext<SubmitIssuedCheckProps>({
  form: null as any,
  clients: [],
  accounts: [],
  fileMappings: [],
  checkList: null as any,
  loading: false,
  loadingClients: false,
  listLoading: false,
  disabled: false,
  validatedFromBE: false,
  onSubmit: () => Promise.resolve(),
  setValidatedFromBE: () => {},
  beforeUpload: () => Promise.resolve(),
})

export const useSubmitIssuedCheckFile = () => React.useContext(SubmitIssuedCheckFileContext)
